export default {
    something_wrong:"Fail to create betting",
    please_input_amount :"Please Input Amount",
    game_close:"Game Closed please wait, thank you",
    processing_previous_betting:"Your Previous invoice is processing, please wait",
    SUCCESS:"SUCCESS"
};
